<span class="md-inputfield filterItem" *ngIf="!jobRefId">
  <input
    id="orgNameInput"
    #orgNameInput
    autofocus
    (ngModelChange)="searchTextChanged($event)"
    [(ngModel)]="searchText"
    autocomplete="off"
    class="search-box"
    name="orgName"
    pInputText
    placeholder="Search Job Number"
    spellcheck="false"
    type="text"
  />
</span>
<div *ngIf="jobRefId" class="table-inset" style="padding-right: 15px; overflow-y: auto">
  <ng-container
    *ngTemplateOutlet="tableTemplate; context: { $implicit: selectedJob }"
  ></ng-container>
</div>

<div>
  <div
    *ngIf="jobInfos == suggestedJobInfos && jobInfos?.length > 0; else searchResult"
    class="job-list-label"
  >
    Recommended
  </div>
  <ng-template #searchResult>
    <div *ngIf="jobInfos?.length > 0" class="job-list-label">Search Results</div>
  </ng-template>

  <div class="table-inset" style="height: 100px; overflow-y: scroll">
    <ng-container
      *ngTemplateOutlet="tableTemplate; context: { $implicit: jobInfos }"
    ></ng-container>
  </div>
</div>

<ng-template #tableTemplate let-data>
  <table
    *ngIf="data?.length > 0"
    class="metric-table table-striped job-view"
    style="width: 100%; font-size: 0.8rem"
  >
    <tbody>
      <tr
        (click)="jobSelected(job)"
        *ngFor="let job of data; let i = index"
        [ngClass]="{ 'selected-row': jobRefId == job.id }"
      >
        <td style="text-align: left; width: 100px">
          <div style="font-weight: bold">{{ job.jobNumber }}</div>
        </td>
        <td style="text-align: left; width: 34px">
          <div>{{ job.orderCount }}</div>
        </td>
        <td
          style="width: 200px"
          [pTooltip]="job.taskVRMs"
          tooltipStyleClass="xtooltip xtooltip-small"
          tooltipPosition="top"
        >
          <span>{{ job.taskVRMs }}</span>
        </td>
        <td
          [pTooltip]="job.jobStatus"
          tooltipPosition="top"
          tooltipStyleClass="xtooltip xtooltip-small"
          style="text-align: center; width: 100px"
        >
          <span
            style="
              display: inline-block;
              background-color: rgba(0, 0, 0, 0.2);
              border-radius: 3px;
              padding: 2px 4px;
              color: white;
            "
          >
            {{ job.jobStatus }}</span
          >
        </td>
        <td style="width: 32px">
          <div
            *ngIf="job.selected && data == selectedJob"
            pTooltip="Remove job reference"
            style="cursor: pointer; text-align: center"
            (click)="removeJobRef()"
          >
            <i class="fa fa-times"></i>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</ng-template>
